
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'
import cssToObjectMixin from '~/mixins/cssToObject'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin, cssToObjectMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      element: null,
      isSVG: false,
      imgSrc: null,
      imgAlt: '',
    }
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.maxWidth = this.getBreakpointValue(this.blok?.maxWidth)
      styles.margin = this.getBreakpointValue(this.blok?.margin)
      styles.padding = this.getBreakpointValue(this.blok?.padding)
      styles.top = this.getBreakpointValue(this.blok?.top)
      styles.right = this.getBreakpointValue(this.blok?.right)
      styles.bottom = this.getBreakpointValue(this.blok?.bottom)
      styles.left = this.getBreakpointValue(this.blok?.left)

      if (this.blok?.height || this.blok?.width) {
        styles.width = this.getBreakpointValue(this.blok?.width)
        styles.height = this.getBreakpointValue(this.blok?.height)
      }

      if (this.blok?.position) {
        styles.position = this.getBreakpointValue(this.blok?.position)
        styles.top = this.getBreakpointValue(this.blok?.top)
        styles.right = this.getBreakpointValue(this.blok?.right)
        styles.bottom = this.getBreakpointValue(this.blok?.bottom)
        styles.left = this.getBreakpointValue(this.blok?.left)
      }

      return styles
    },
    overlayStyles() {
      let styles = {}

      styles.background = this.blok?.hoverOverlayColor || '#fff'
      styles.backdropFilter = 'blur(6px)'

      if (this.blok.overlayStyles) {
        styles = {
          ...styles,
          ...this.parseCSSToObject(this.blok?.overlayStyles),
        }
      }

      return styles
    },
    aspectRatioContainerStyles() {
      const styles = {}

      styles.paddingBottom = `calc(100% / calc(${this.getBreakpointValue(
        this.blok?.aspectRatio
      )}))`

      return styles
    },
    imgStyles() {
      let styles = {}

      styles.objectFit = this.blok?.objectFit
      styles.objectPosition = this.blok?.objectPosition
      styles.border = this.blok?.border

      if (this.blok?.height || this.blok?.width) {
        styles.width = this.getBreakpointValue(this.blok?.width)
        styles.height = this.getBreakpointValue(this.blok?.height)
      }

      if (this.blok.styles) {
        styles = {
          ...styles,
          ...this.parseCSSToObject(this.blok?.styles),
        }
      }

      return styles
    },
    imageSource() {
      const isMobile = this.getBreakpointValue(this.blok.mobileBreakpoint)

      const desktopSrc = this.blok.src?.[0]?.filename
      const mobileSrc = this.blok.src?.[1]?.filename || desktopSrc

      if (isMobile === 'true') {
        return mobileSrc
      } else {
        return desktopSrc
      }
    },
    imageAlt() {
      const isMobile = this.getBreakpointValue(this.blok.mobileBreakpoint)

      const desktopAlt = this.blok.src?.[0]?.alt
      const mobileAlt = this.blok.src?.[1]?.alt || desktopAlt

      if (isMobile === 'true') {
        return mobileAlt
      } else {
        return desktopAlt
      }
    },
  },
}
